export const Maps = {
    // openrouteservice: '5b3ce3597851110001cf62482c1e53b2bf684062ae1216c132f48103',
    // openrouteservice: '5b3ce3597851110001cf624846a3b0b8b8c84570a128c12e3364fe82',
    openrouteservice: '5b3ce3597851110001cf6248e70cd9a288b84f6aa2015c0a16c4e81a',
    google: 'AIzaSyC2cpwWmoGuaXzrc2g8LNoOW-nTaJ558-k'
}